import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import { Link } from 'react-router-dom';
import CallToAction from '../components/CallToAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
// EmailJS removed - using AWS Lambda instead
import './Projects.css';

// Import images
import projectsHeroImage from '../assets/images/projects.jpg';
import edtechImage from '../assets/images/edtech.jpg';
import aiImage from '../assets/images/ai.jpg';
import softwareImage from '../assets/images/software.jpg';
import webImage from '../assets/images/web.jpg';
import kurumImage from '../assets/images/kurum.jpg';
import socialImage from '../assets/images/social.jpg';

const Projects = () => {
  const [showProjectForm, setShowProjectForm] = useState(false);
  const [projectFormData, setProjectFormData] = useState({
    name: '',
    email: '',
    phone: '',
    customerType: 'individual',
    projectType: '',
    projectDetails: '',
    message: ''
  });
  const [isSubmittingProject, setIsSubmittingProject] = useState(false);
  const [projectSubmitStatus, setProjectSubmitStatus] = useState(null);

  const projectTypes = [
    'Eğitim Teknolojileri',
    'Veri Bilimi ve Yapay Zeka',
    'Mobil ve Web Uygulamaları',
    'Kurumsal Web Çözümleri',
    'Kurumsal Yazılım',
    'IoT Çözümleri',
    'Gömülü Sistemler',
    'Diğer'
  ];

  const handleProjectFormChange = (e) => {
    const { name, value } = e.target;
    setProjectFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    if (projectSubmitStatus) setProjectSubmitStatus(null);
  };

  const handleProjectFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingProject(true);
    setProjectSubmitStatus(null);

    const lambdaUrl = process.env.REACT_APP_LAMBDA_PROJECT_REQUEST_URL;

    if (!lambdaUrl) {
      console.error('Lambda URL yapılandırması eksik!');
      setIsSubmittingProject(false);
      setProjectSubmitStatus('error');
      return;
    }

    try {
      const response = await fetch(lambdaUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: projectFormData.name,
          email: projectFormData.email,
          phone: projectFormData.phone || '',
          customerType: projectFormData.customerType,
          projectType: projectFormData.projectType,
          projectDetails: projectFormData.projectDetails || '',
          message: projectFormData.message || '',
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Proje isteği gönderilirken bir hata oluştu.');
      }

      setProjectSubmitStatus('success');
      setProjectFormData({
        name: '',
        email: '',
        phone: '',
        customerType: 'individual',
        projectType: '',
        projectDetails: '',
        message: ''
      });
      setTimeout(() => setProjectSubmitStatus(null), 3000);
    } catch (error) {
      console.error('Lambda Error:', error);
      setProjectSubmitStatus('error');
      setTimeout(() => setProjectSubmitStatus(null), 3000);
    } finally {
      setIsSubmittingProject(false);
    }
  };

  const projectsData = [
    {
      id: 1,
      title: 'Eğitim Teknolojileri',
      description: 'ProgenX Akademi platformu, yapay zeka destekli kişiselleştirilmiş öğrenme deneyimi sunan, öğrencilerin bireysel öğrenme ihtiyaçlarına göre optimize edilmiş eğitim programları oluşturan yenilikçi bir çözümdür.',
      category: 'edtech',
      image: edtechImage,
      path: '/projeler/egitim-teknolojileri'
    },
    {
      id: 2,
      title: 'Veri Bilimi ve Yapay Zeka',
      description: 'Büyük veri setlerinden anlamlı bilgiler çıkaran, işletmelerin karar alma süreçlerine güç katan gelişmiş veri analizi ve yapay zeka çözümleri geliştiriyoruz.',
      category: 'ai',
      image: aiImage,
      path: '/projeler/veri-bilimi-yapay-zeka'
    },
    {
      id: 3,
      title: 'Mobil ve Web Uygulamaları',
      description: 'Kullanıcı dostu, yüksek performanslı dijital ürünler yaratıyor ve iş süreçlerini dijitalleştiren mobil ve web uygulamaları geliştiriyoruz.',
      category: 'software',
      image: softwareImage,
      path: '/projeler/mobil-web-uygulamalari'
    },
    {
      id: 4,
      title: 'Kurumsal Web Çözümleri',
      description: 'Modern ve etkileyici web siteleri oluşturarak müşterilerimizin dijital varlığını güçlendiren, işletmelere özel entegre dijital çözümler sunuyoruz.',
      category: 'web',
      image: webImage,
      path: '/projeler/kurumsal-web-cozumleri'
    },
    {
      id: 5,
      title: 'Kurumlara ve Yayınevlerine Yazılım Desteği',
      description: 'Eğitim kurumları ve yayınevleri için özel olarak geliştirdiğimiz interaktif içerikler, SCORM uyumlu eğitim materyalleri, akıllı tahta uygulamaları ve kurumsal sistemler sunuyoruz.',
      category: 'corporate',
      image: kurumImage,
      path: '/projeler/kurumsal-yazilim'
    },
    {
      id: 6,
      title: 'Sosyal Sorumluluk Projeleri',
      description: 'HAVELSAN F5 Yönetici Gelişim Akademisi kapsamında, Hatay Naim Atakaş Anadolu Lisesi\'nde öğrencilere eğitim teknolojileri alanındaki yazılım ürünümüzün beta sürümünü ücretsiz olarak kullanma imkanı sunduk.',
      category: 'social',
      image: socialImage,
      path: '/projeler/sosyal-sorumluluk'
    },
    {
      id: 7,
      title: 'IoT ve Akıllı Sistemler',
      description: 'Nesnelerin interneti ve gömülü sistem çözümleri ile endüstriyel süreçleri optimize eden, akıllı cihaz yönetimi ve gerçek zamanlı veri toplama altyapıları geliştiriyoruz.',
      category: 'iot',
      image: softwareImage,
      path: '/projeler/gomulu-sistemler'
    },
    {
      id: 8,
      title: 'Akıllı Raporlama ve Analitik',
      description: 'İşletmelerin verilerini anlamlı raporlara dönüştüren, gerçek zamanlı dashboard\'lar ve gelişmiş analitik araçlarıyla karar alma süreçlerini hızlandıran çözümler sunuyoruz.',
      category: 'analytics',
      image: aiImage,
      path: '/projeler/veri-bilimi-yapay-zeka'
    }
  ];

  const faqData = [
    {
      question: "ProgenX hangi alanlarda projeler geliştiriyor?",
      answer: "ProgenX, eğitim teknolojileri, veri bilimi ve yapay zeka, mobil ve web uygulamaları, kurumsal web çözümleri, eğitim kurumları ve yayınevleri için yazılım desteği ile sosyal sorumluluk projeleri alanlarında çalışmaktadır."
    },
    {
      question: "Eğitim teknolojileri projeleriniz neler sunuyor?",
      answer: "Yapay zeka destekli kişiselleştirilmiş öğrenme platformları, akıllı soru çözüm sistemleri, detaylı ilerleme takibi ve eğlenceli interaktif içerikler sunuyoruz. Her öğrencinin kendi hızında öğrenmesini sağlıyoruz."
    },
    {
      question: "Veri bilimi ve yapay zeka çözümleriniz ne işe yarar?",
      answer: "İşletmelerin verilerini analiz ederek anlamlı içgörüler çıkarıyoruz. Geleceği öngören tahminler yapıyor, otomatik kararlar alıyor ve süreçleri optimize ediyoruz. Böylece işletmeler daha iyi kararlar alır, maliyetlerini düşürür."
    },
    {
      question: "Mobil ve web uygulamaları geliştirme süreci nasıl işliyor?",
      answer: "İşletmenizin ihtiyaçlarını anlayarak, kullanıcı dostu ve hızlı uygulamalar geliştiriyoruz. Müşterilerinize her yerden erişim sağlayan, güvenilir ve modern çözümler sunuyoruz. Proje süresince sizinle yakın çalışıyor, geliştirme sonrası da destek sağlıyoruz."
    },
    {
      question: "Eğitim kurumları için ne tür çözümler sunuyorsunuz?",
      answer: "Eğitim kurumları için standartlara uygun eğitim içerikleri, etkileşimli öğrenme materyalleri, akıllı tahta uygulamaları ve kurumsal yönetim sistemleri geliştiriyoruz. Eğitim süreçlerini daha verimli hale getiriyoruz."
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "ProgenX",
    "url": "https://progenx.com.tr",
    "logo": "https://progenx.com.tr/logo.png",
    "description": "ProgenX, eğitim teknolojileri, veri bilimi, yapay zeka, mobil ve web uygulama geliştirme alanlarında yenilikçi çözümler sunan teknoloji şirketi.",
    "sameAs": [
      "https://www.linkedin.com/company/progenx",
      "https://twitter.com/progenx"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "ProgenX Projeler",
      "itemListElement": projectsData.map((project, index) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": project.title,
          "description": project.description,
          "url": `https://progenx.com.tr${project.path}`
        },
        "position": index + 1
      }))
    }
  };

  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <div className="projects">
      <Helmet>
        <title>ProgenX Projeler | Eğitim Teknolojileri, Yapay Zeka ve Yazılım Çözümleri 2026</title>
        <meta name="description" content="ProgenX'in eğitim teknolojileri, yapay zeka destekli öğrenme platformları, veri bilimi çözümleri, mobil uygulama geliştirme, kurumsal web siteleri ve sosyal sorumluluk projeleri. Türkiye'nin önde gelen teknoloji çözümleri şirketi." />
        <meta name="keywords" content="progenx projeler, eğitim teknolojileri, yapay zeka çözümleri, veri bilimi, mobil uygulama geliştirme, web uygulama geliştirme, kurumsal yazılım, eğitim yazılımı, dijital dönüşüm, türkiye teknoloji şirketi" />
        <meta property="og:title" content="ProgenX Projeler | Eğitim Teknolojileri ve Yazılım Çözümleri" />
        <meta property="og:description" content="Eğitim teknolojileri, yapay zeka, veri bilimi, mobil ve web uygulama geliştirme alanlarında yenilikçi çözümler. ProgenX ile dijital dönüşümünüzü başlatın." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr/projeler" />
        <meta property="og:image" content="https://progenx.com.tr/projects.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ProgenX Projeler | Teknoloji Çözümleri" />
        <meta name="twitter:description" content="Eğitim teknolojileri, yapay zeka ve yazılım çözümleri ile dijital dönüşümünüzü başlatın." />
        <link rel="canonical" href="https://progenx.com.tr/projeler" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqStructuredData)}
        </script>
      </Helmet>
      
      <Hero 
        title="PROJELER" 
        backgroundImage={projectsHeroImage}
      />
      
      <section className="projects-content">
        <div className="container">
          <h2 className="section-title">Neler Yapıyoruz?</h2>
          <p className="projects-intro">
            ProgenX olarak, eğitimden iş dünyasına kadar geniş bir yelpazede dijital çözümler geliştiriyoruz. 
            Yapay zeka destekli eğitim platformlarından, işletmelerin verilerini değere dönüştüren analitik çözümlere, 
            modern web ve mobil uygulamalardan kurumsal yazılım çözümlerine kadar, teknolojiyi insanların hayatını 
            kolaylaştırmak için kullanıyoruz.
          </p>
          
          <div className="projects-grid">
            {projectsData.map(project => (
              <Link to={project.path} key={project.id} className="project-item">
                <img 
                  src={project.image} 
                  alt={`ProgenX ${project.title} projesi - ${project.description.substring(0, 50)}...`}
                  className="project-image"
                  loading="lazy"
                />
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-category">{project.category}</div>
              </Link>
            ))}
          </div>
          
          <div className="support-section">
            <h3>Projeniz İçin Bizimle Çalışın</h3>
            <p>
              Dijital dönüşüm yolculuğunuzda yanınızdayız. Eğitim kurumlarından işletmelere, 
              bireysel projelerden kurumsal çözümlere kadar her türlü ihtiyacınız için 
              profesyonel destek sunuyoruz. Hayalinizdeki projeyi birlikte gerçeğe dönüştürelim.
            </p>
            <div className="support-buttons">
              <button 
                onClick={() => setShowProjectForm(true)} 
                className="btn btn-primary"
              >
                PROJE İSTEĞİ GÖNDER
              </button>
              <Link to="/iletisim" className="btn">İLETİŞİME GEÇ</Link>
            </div>
          </div>

          {/* Proje İsteği Formu */}
          <div className="project-request-section">
            <h2 className="section-title">Proje İsteği Gönder</h2>
            <p className="section-subtitle">
              Kurum veya bireysel olarak proje talebinizi bize iletin. Size en kısa sürede dönüş yapacağız.
            </p>
            <div className="project-request-form-container">
              {projectSubmitStatus === 'success' && (
                <div className="form-message success">
                  <FontAwesomeIcon icon={faCheckCircle} />
                  <span>İletildi</span>
                </div>
              )}
              {projectSubmitStatus === 'error' && (
                <div className="form-message error">
                  <span>İletilemedi</span>
                </div>
              )}
              <form onSubmit={handleProjectFormSubmit} className="project-request-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Adınız Soyadınız *</label>
                    <input 
                      type="text" 
                      name="name" 
                      value={projectFormData.name} 
                      onChange={handleProjectFormChange} 
                      placeholder="Adınız Soyadınız"
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <label>E-posta Adresiniz *</label>
                    <input 
                      type="email" 
                      name="email" 
                      value={projectFormData.email} 
                      onChange={handleProjectFormChange} 
                      placeholder="ornek@email.com"
                      required 
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Telefon (Opsiyonel)</label>
                    <input 
                      type="tel" 
                      name="phone" 
                      value={projectFormData.phone} 
                      onChange={handleProjectFormChange} 
                      placeholder="0555 123 45 67"
                    />
                  </div>
                  <div className="form-group">
                    <label>Müşteri Tipi *</label>
                    <select 
                      name="customerType" 
                      value={projectFormData.customerType} 
                      onChange={handleProjectFormChange} 
                      required
                    >
                      <option value="individual">Bireysel</option>
                      <option value="company">Şirket</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Proje Tipi *</label>
                  <select 
                    name="projectType" 
                    value={projectFormData.projectType} 
                    onChange={handleProjectFormChange} 
                    required
                  >
                    <option value="">Seçiniz...</option>
                    {projectTypes.map((type, index) => (
                      <option key={index} value={type}>{type}</option>
                    ))}
                  </select>
                </div>
                {projectFormData.projectType === 'Diğer' && (
                  <div className="form-group">
                    <label>Proje Detayı *</label>
                    <textarea 
                      name="projectDetails" 
                      value={projectFormData.projectDetails} 
                      onChange={handleProjectFormChange} 
                      placeholder="Projenizi detaylı olarak açıklayın..."
                      rows="4"
                      required
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Mesaj (Opsiyonel)</label>
                  <textarea 
                    name="message" 
                    value={projectFormData.message} 
                    onChange={handleProjectFormChange} 
                    placeholder="Eklemek istediğiniz başka bir şey var mı?"
                    rows="4"
                  />
                </div>
                <button 
                  type="submit" 
                  className="btn btn-primary" 
                  disabled={isSubmittingProject}
                  style={{ width: '100%', maxWidth: '400px', margin: '20px auto 0', display: 'block' }}
                >
                  {isSubmittingProject ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin /> Gönderiliyor...
                    </>
                  ) : (
                    'PROJE İSTEĞİ GÖNDER'
                  )}
                </button>
              </form>
            </div>
          </div>

          {/* Project Request Modal */}
          {showProjectForm && (
            <div className="project-form-modal" onClick={() => setShowProjectForm(false)}>
              <div className="project-form-content" onClick={(e) => e.stopPropagation()}>
                <button 
                  className="close-modal-btn"
                  onClick={() => setShowProjectForm(false)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
                <h3>Proje İsteği Gönder</h3>
                {projectSubmitStatus === 'success' && (
                  <div className="form-message success">
                    <FontAwesomeIcon icon={faCheckCircle} />
                    <span>Proje isteğiniz başarıyla gönderildi! En kısa sürede size dönüş yapacağız.</span>
                  </div>
                )}
                {projectSubmitStatus === 'error' && (
                  <div className="form-message error">
                    <span>Bir hata oluştu. Lütfen tekrar deneyin.</span>
                  </div>
                )}
                <form onSubmit={handleProjectFormSubmit}>
                  <div className="form-group">
                    <label>Adınız Soyadınız *</label>
                    <input 
                      type="text" 
                      name="name" 
                      value={projectFormData.name} 
                      onChange={handleProjectFormChange} 
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <label>E-posta Adresiniz *</label>
                    <input 
                      type="email" 
                      name="email" 
                      value={projectFormData.email} 
                      onChange={handleProjectFormChange} 
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <label>Telefon (Opsiyonel)</label>
                    <input 
                      type="tel" 
                      name="phone" 
                      value={projectFormData.phone} 
                      onChange={handleProjectFormChange} 
                    />
                  </div>
                  <div className="form-group">
                    <label>Müşteri Tipi *</label>
                    <select 
                      name="customerType" 
                      value={projectFormData.customerType} 
                      onChange={handleProjectFormChange} 
                      required
                    >
                      <option value="individual">Bireysel</option>
                      <option value="company">Şirket</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Proje Tipi *</label>
                    <select 
                      name="projectType" 
                      value={projectFormData.projectType} 
                      onChange={handleProjectFormChange} 
                      required
                    >
                      <option value="">Seçiniz...</option>
                      {projectTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>
                  {projectFormData.projectType === 'Diğer' && (
                    <div className="form-group">
                      <label>Proje Detayı *</label>
                      <textarea 
                        name="projectDetails" 
                        value={projectFormData.projectDetails} 
                        onChange={handleProjectFormChange} 
                        placeholder="Projenizi detaylı olarak açıklayın..."
                        rows="4"
                        required
                      />
                    </div>
                  )}
                  <div className="form-group">
                    <label>Mesaj (Opsiyonel)</label>
                    <textarea 
                      name="message" 
                      value={projectFormData.message} 
                      onChange={handleProjectFormChange} 
                      placeholder="Eklemek istediğiniz başka bir şey var mı?"
                      rows="4"
                    />
                  </div>
                  <button 
                    type="submit" 
                    className="btn btn-primary" 
                    disabled={isSubmittingProject}
                  >
                    {isSubmittingProject ? (
                      <>
                        <FontAwesomeIcon icon={faSpinner} spin /> Gönderiliyor...
                      </>
                    ) : (
                      'GÖNDER'
                    )}
                  </button>
                </form>
              </div>
            </div>
          )}

          <section className="faq-section">
            <h2 className="section-title">Sıkça Sorulan Sorular</h2>
            <div className="faq-container">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <h3 className="faq-question">{faq.question}</h3>
                  <p className="faq-answer">{faq.answer}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </section>
      
      <CallToAction 
        title="Dijital Geleceğinizi Birlikte Şekillendirelim"
        subtitle="Teknoloji ile hayallerinizi gerçeğe dönüştürmek için buradayız."
        buttonText="Bize Ulaşın" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default Projects; 
